/**
 * TipTap Block Editor Constants
 *
 * This file contains shared constants used across TipTap components
 * to ensure consistency and avoid duplication.
 */

// Text alignment constants
export const ALIGNMENT_TYPES = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
} as const;

/**
 * List of TipTap node types that support text alignment.
 *
 * These are the element types that can be used with the TextAlign extension.
 * Based on TipTap documentation and common usage patterns.
 *
 * @see https://tiptap.dev/docs/editor/extensions/functionality/textalign
 */
export const ALIGNABLE_ELEMENTS = [
  "paragraph",
  "heading",
  "listItem",
  "blockquote",
] as const;

export type AlignmentType =
  (typeof ALIGNMENT_TYPES)[keyof typeof ALIGNMENT_TYPES];
